// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oc2N","title":"Header_title__3U0mX","side":"Header_side__1dhMI"};